import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { init, refreshToken } from '../../auth/handleTokens';
import { constants } from '../../constants';


const TagInputs = (props) => {
    const [tags, setTags] = useState([]);
    const [dataGroups, setDataGroups]= useState([]);

    // const isAndroid = navigator.userAgent.toLowerCase().indexOf('android') >= 0;

    // const keyCode = function () {
    //     const input = this.currentTarget;
    //     return input.value.charAt(input.selectionStart - 1).charCodeAt();
    // };

    // const keyup = (e)=> {

    //     const code = this.isAndroid
    //         ? keyCode.call(e)
    //         : (e.code || e.keyCode);

    //     // Realizar tus chequeos
    //     if (code >= 48 && code <= 57) {
        
    //     }

    // }
    
    const handleKeyDown = e => {

        if(e.key !== 'Enter' && e.key !== ' ' && e.key !== ',') return
        const value = e.target.value
        if(!value.trim()) return
        setTags([...tags, value.trim()]);
        setTimeout(()=> {
            e.target.value = '';
        },100)
    }

    const handleSelect = (e) => {
        if(e.target.value === 'Seleccione') return
        const val = tags.findIndex((el)=> e.target.value === el);
        if(val!== -1) return
        const value = e.target.value;
        setTags([...tags, value]);
        e.target.value = 'Seleccione'
    }

    const getGroups = async() => {
        try {
            const result = await init();
            if(!result) return
            const token = window.localStorage.getItem('at');
            const URL = constants.test_host + '/user/groups/list'
            const {data} = await axios.get(URL, {headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true})
            setDataGroups(data.groups);
            
        } catch (error) {
            if(error === 401) {
                const result = await refreshToken();
                if(result) getGroups();
                else {
                    window.localStorage.clear();
                    return window.location.href = '/login';
                }
            }else {
                window.localStorage.clear();
                return window.location.href = '/login';
            }
        }
    }

    const listGroups = dataGroups.map((group) => 
      <option key={group._id}>{group.name}</option>
    )

    const removeTag = index => {
        setTags(tags.filter((el, i) => i!== index))
    }


    useEffect(() => {
        if(!props.start) getGroups();
    },[props.id, props.start])

    useEffect(()=> {
       setTags([]);
    }, [props.restart])

  return (
    <div className='tag-input-container'>
        
        {tags.map((tag, index) => (
            <div className='tag-item' key={index}>
            <span className='text'>{tag}</span>
            <span className='close' onClick={()=>removeTag(index)}>x</span>
        </div>
        ))}
        <input onKeyDown={handleKeyDown} type='text' style={{display: props.display}} placeholder= "escribe y presiona enter o espacio" className='tags-input' />
        {props.select && <select onChange={handleSelect} style={{fontSize:'12px', marginRight: '5px'}} >
                <option>Seleccione</option>
                {listGroups}
        </select>}
    </div>
  )
}

export default TagInputs
